export const dataClient = [
    {
        id: 1,
        title: "HTML",
        link: "/assets/images/html5-color.svg"
    },
    {
        id: 2,
        title: "CSS",
        link: "/assets/images/css3-color.svg"
    },
    {
        id: 3,
        title: "JavaScript",
        link: "/assets/images/javascript-color.svg"
    },
    {
        id: 10,
        title: "TypeScript",
        link: "/assets/images/typescript-color.svg"
    },
    {
        id: 4,
        title: "jQuery",
        link: "/assets/images/jquery-color.svg"
    },
    {
        id: 5,
        title: "Bootstrap",
        link: "/assets/images/bootstrap-color.svg"
    },
    {
        id: 6,
        title: "Tailwind CSS",
        link: "/assets/images/tailwindcss-color.svg"
    },
    {
        id: 7,
        title: "ReactJS",
        link: "/assets/images/react-color.svg"
    },
    {
        id: 8,
        title: "React Native",
        link: "/assets/images/react-color.svg"
    },
    {
        id: 9,
        title: "NextJS",
        link: "/assets/images/nextjs-icon-dark-background.png"
    },
]

export const dataServer = [
    {
        id: 1,
        title: "NodeJS",
        link: "/assets/images/nodedotjs-color.svg"
    },
    {
        id: 2,
        title: "Express JS",
        link: "/assets/images/nodedotjs-color.svg"
    },
    {
        id: 3,
        title: "ASP.NET",
        link: "/assets/images/dotnet-color.svg"
    },
    {
        id: 8,
        title: "GraphQL",
        link: "/assets/images/graphql-color.svg"
    },
    {
        id: 6,
        title: "Strapi",
        link: "/assets/images/strapi-color.svg"
    },
    {
        id: 10,
        title: "MySQL",
        link: "/assets/images/mysql-color.svg"
    },
    {
        id: 4,
        title: "PostgreSQL",
        link: "/assets/images/postgresql-color.svg"
    },
    {
        id: 5,
        title: "MongoDB",
        link: "/assets/images/mongodb-color.svg"
    },
    {
        id: 7,
        title: "Docker",
        link: "/assets/images/docker-color.svg"
    },
    {
        id: 10,
        title: "Redis",
        link: "/assets/images/redis-color.svg"
    },
]

export const dataOther = [
    {
        id: 15,
        title: "Magento 2",
        link: "/assets/images/magento-color.svg"
    },
    {
        id: 20,
        title: "Wordpress",
        link: "/assets/images/wordpress-color.svg"
    }
]